// Bump the version suffix to re-show the tutorial after meaningful changes.
export const VIDEO_TUTORIAL_SEEN_KEY = "video_tutorial_seen_v1";

// Steps are resolved by the `data-tour` attribute on each element. Steps whose
// target is missing (e.g. the full-sequence chip when an event has no sequence)
// are skipped automatically by SpotlightTour. Copy is localized via i18next —
// pass the page's `t` function.
export const buildVideoTutorialSteps = (t) => [
  {
    selector: '[data-tour="video-events"]',
    title: t("videoTutorial.eventsTitle"),
    body: t("videoTutorial.eventsBody"),
  },
  {
    selector: '[data-tour="video-group-sequences"]',
    title: t("videoTutorial.groupSequencesTitle"),
    body: t("videoTutorial.groupSequencesBody"),
  },
  {
    selector: '[data-tour="video-analyst-mode"]',
    title: t("videoTutorial.analystModeTitle"),
    body: t("videoTutorial.analystModeBody"),
  },
  {
    selector: '[data-tour="video-player"]',
    title: t("videoTutorial.playerTitle"),
    body: t("videoTutorial.playerBody"),
  },
  {
    selector: '[data-tour="video-full-sequence"]',
    title: t("videoTutorial.fullSequenceTitle"),
    body: t("videoTutorial.fullSequenceBody"),
  },
  {
    selector: '[data-tour="video-actions"]',
    title: t("videoTutorial.actionsTitle"),
    body: t("videoTutorial.actionsBody"),
  },
];
